// StatusBadge.jsx
import React from 'react';

const StatusBadge = ({ status, type }) => {
  if (type === 'invitation' || status === 'pending') {
    return <span className="status-badge status-pending">Pending</span>;
  }
  
  switch (status) {
    case 'active':
      return <span className="status-badge status-active">Active</span>;
    case 'inactive':
      return <span className="status-badge status-inactive">Inactive</span>;
    case 'suspended':
      return <span className="status-badge status-suspended">Suspended</span>;
    default:
      return <span className="status-badge">{status}</span>;
  }
};

// RoleBadge.jsx
const RoleBadge = ({ role, isOwner }) => {
  const displayText = isOwner ? 'Owner' : role?.name;
  
  return (
    <span className="role-badge">
      {displayText || 'N/A'}
    </span>
  );
};

// LoadingSpinner.jsx
const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>{message}</p>
    </div>
  );
};

// ErrorDisplay.jsx
const ErrorDisplay = ({ error, onRetry }) => {
  return (
    <div className="error-container">
      <p>Error: {error}</p>
      {onRetry && (
        <button onClick={onRetry} className="sgl-button button">
          Retry
        </button>
      )}
    </div>
  );
};

// DateFormatter utility
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString();
};

export { StatusBadge, RoleBadge, LoadingSpinner, ErrorDisplay, formatDate };